export default __webpack_public_path__ + "static/media/nut-bg-3.61232c81.png";